export default "/assets/united-states.png"